export const actionType = {
    addStore: 'addStore',
    deleteStore: 'deleteStore',
    setSelectedStoreId: 'setSelectedStoreId',
    setIsHideStoreMarker: 'setIsHideStoreMarker',
};
const action = {
    [actionType.addStore]({ commit }, store) {
        commit('ADD_STORE', store);
    },
    [actionType.deleteStore]({ commit }, storeId) {
        commit('DELETE_STORE', storeId);
    },
    [actionType.setSelectedStoreId]({ commit }, storeId) {
        commit('SET_SELECTED_STORE_ID', storeId);
    },
    [actionType.setIsHideStoreMarker]({ commit }, isHide) {
        commit('SET_IS_HIDE_STORE_MARKER', isHide);
    },
};
export default action;
